import { render, staticRenderFns } from "./WorkContact.vue?vue&type=template&id=6d719dfd&scoped=true"
import script from "./WorkContact.vue?vue&type=script&lang=js"
export * from "./WorkContact.vue?vue&type=script&lang=js"
import style0 from "./WorkContact.vue?vue&type=style&index=0&id=6d719dfd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d719dfd",
  null
  
)

export default component.exports